import React from 'react';
import PropTypes from 'prop-types';
import Dotdotdot from 'react-dotdotdot';

const Header = ({ image = '', text = '', theme = {} }) => (
  <>
    {image ? (
      <div className={theme.logo}>
        <img src={image} alt={text} />
      </div>
    ) : (
      <div className={theme.headline}>
        <Dotdotdot clamp={3}>{text}</Dotdotdot>
      </div>
    )}
  </>
);

export default Header;

Header.propTypes = {
  image: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  theme: PropTypes.shape({}).isRequired,
};
